import React, { Fragment, useState, useEffect, useMemo, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { PageView, initGA } from './Tracking';


import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField'
import classnames from 'classnames'
import PhoneInput from './ui/phoneInput';
import EditIcon from '@material-ui/icons/Edit';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'
import ToggleButton from '@material-ui/lab/ToggleButton'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'
import CardForm from './ui/cardForm';
import DatePicker from './ui/DatePicker'
import AuthEntry, { AUTH_MODES } from './ui/AuthEntry'
import { getEntryParams, ENTRY_TYPES } from './shared/entryParams'
import useEntryContinuation from './shared/useEntryContinuation'
import { signIn } from '../store/actions/authenticationActions'
import { getUserInfo, makeCardAsDefault, updateMemberInfo, addNewCard, addNewBankAcct, deleteCard, changeAllcalName, getFutureTeeTickets, getLinkAccountToken, addNewBankAcctAndMakeDefault, getUpcomingInvoice, updateNameAndEmailAcrossPlatforms } from '../store/actions/accountActions';
import { QRCode } from "react-qr-svg";
import { resetPassword } from '../store/actions/authenticationActions'

import moment from 'moment'
import { CircularProgress, TextareaAutosize } from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { withSnackbar } from 'notistack';

import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom'
import BankAccountForm from './ui/bankAccountForm';
import VerifyAmountForm from './ui/verifyAmountForm';
import LinkAccountButton from './ui/linkAccountButton';

import { Link as MaterialLink } from '@material-ui/core'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import SlideInModal from './ui/slideInModal';
import {Typography} from '@material-ui/core';

import { ACHDiscountWrapper } from './shared/genericFunctions'
import classNames from 'classnames';
import { getMemberFamily, inviteUser, logInvitedMember, getMembershipPhases, setAddOnBillingAuthorization } from '../store/actions/membershipActions';
import AddOnMemberList from './ui/AddOnMemberList';
import StatusBadge from './shared/StatusBadge';
import AutopayPanel from './ui/AutopayPanel';
import { constants } from '../App.constants';
import MembershipUpgrades from './ui/MembershipUpgrades';
import { ONGOING } from './shared/membershipTerm'
import * as renewGate from './shared/renewGate'
import { formatPhone334 } from './shared/phoneFormat'
import ConfirmDetails from './shared/ConfirmDetails'
import ContractSign from './ui/contractSign';
import { currentPricing, golfMemberBenefits, socialMemberBenefits } from './docs/memberBenefits';
import { genHex } from './shared/genericFunctions';
import { getRenewalOption, handleRenewalScheduled, planRenewal, startRenewal, renewAfterSigning, RENEWAL_MODES, isInRenewalWindow } from './shared/renewal';
import { primaryHasRenewed, primaryRenewalStartKey, addOnsToList, ownPendingRenewal, coveredMembershipDisplay, ownRenewalTerm } from './shared/addOnRenewal';
import { membershipTerms } from './shared/membershipTerm';
import TermCard from './ui/TermCard';
import AddOnBillingQuestion from './ui/AddOnBillingQuestion';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

const styles = (theme) => ({
    root: {
        background: theme.palette.background.default,
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(0),
        },
        width: '100%'

    },
    marginTop10Xs: {
        marginTop: theme.spacing(10),

    },
    indicator: {
        backgroundColor: 'transparent',
    },
    checkoutContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        marginTop: theme.spacing(4)

    },
    header: {
        fontSize: theme.spacing(3),
        fontWeight: 700,
        color: theme.palette.text.primary,
        textTransform: 'uppercase'
    },
    topContainer: {
        width: '100%',
        paddingBottom: theme.spacing(5),
    },
    playersContainer: {
        marginLeft: theme.spacing(2)
    },
    padding2: {
        padding: theme.spacing(2)
    },
    marginTop3: {
        marginTop: theme.spacing(3)
    },
    marginTop8: {
        marginTop: theme.spacing(8)
    },
    marginTop5: {

        marginTop: theme.spacing(5)
    },
    marginTop2: {
        marginTop: theme.spacing(2)
    },
    button: {
        paddingRight: theme.spacing(4),
        paddingLeft: theme.spacing(4),
        letterSpacing: '1px',
        '&:focus, &:hover, &:visited, &:link, &:active': {
            background: 'transparent'
        }
    },
    buttonPay: {
        '&:focus, &:hover, &:visited, &:link, &:active': {
            background: theme.palette.primary.main
        }
    },
    buttonCustomDashed: {
        color: '#009BE1',
        background: 'white',
        fontWeight: 600,
        border: '2px dashed #009BE1'

    },
    marginBottom2: {
        marginBottom: theme.spacing(3)
    },
    marginBottom1: {
        marginBottom: theme.spacing(1)
    },
    bold: {
        fontWeight: '600'
    },
    muted: {
        color: theme.palette.text.disabled
    },
    bgTransparent: {
        background: 'transparent'
    },
    bgWhite: {
        background: 'white'
    },
    // Neutral redesign: the page is a centred column of white cards.
    page: {
        maxWidth: 1180,
        margin: '0 auto',
        padding: theme.spacing(3),
        gap: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2)
        }
    },
    sectionCard: {
        background: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 12,
        padding: theme.spacing(2.5),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2)
        }
    },
    summaryHead: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        flexWrap: 'wrap',
        gap: theme.spacing(2)
    },
    summaryActions: {
        display: 'flex',
        gap: theme.spacing(1),
        flexWrap: 'wrap'
    },
    tiles: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
        gap: theme.spacing(1.5),
        marginTop: theme.spacing(2)
    },
    tile: {
        background: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 12,
        padding: theme.spacing(1.75, 2),
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        minWidth: 0
    },
    tilePrimary: {
        borderColor: theme.palette.primary.main,
        boxShadow: `inset 0 3px 0 ${theme.palette.primary.main}`
    },
    tileLabel: {
        fontSize: '0.72rem',
        fontWeight: 600,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        color: theme.palette.text.secondary
    },
    tileValue: {
        fontSize: '1.05rem',
        fontWeight: 700,
        fontVariantNumeric: 'tabular-nums'
    },
    tileSub: {
        fontSize: '0.8rem',
        color: theme.palette.text.secondary
    },
    notice: {
        marginTop: theme.spacing(1.5),
        padding: theme.spacing(1.25, 1.75),
        borderRadius: 10,
        background: '#e2f3e9',
        color: '#1e7a46',
        fontSize: '0.9rem'
    },
    cardHeadRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: theme.spacing(1)
    },
    authWrap: {
        padding: theme.spacing(5, 2),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2)
        }
    },
    authCard: {
        width: '100%',
        maxWidth: 520,
        background: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 14,
        padding: theme.spacing(1, 3, 2),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(0.5, 1.5, 1.5)
        }
    },
    inviteRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        flexWrap: 'wrap',
        padding: theme.spacing(1.5),
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 12
    },
    inviteEmail: {
        flex: '1 1 260px',
        width: 'auto',
        padding: 0,
        minWidth: 0
    },
    // The theme pads every form label for the filled inputs; an outlined
    // field positions its own label, so the padding knocks it off-centre.
    inviteLabel: {
        padding: 0
    },
    inviteToggleGroup: {
        display: 'inline-flex',
        flex: '0 0 auto',
        width: 'auto'
    },
    inviteToggle: {
        textTransform: 'none',
        fontWeight: 600,
        padding: theme.spacing(0.75, 1.5)
    },
    warnNotice: {
        width: '100%',
        padding: theme.spacing(1.25, 1.75),
        borderRadius: 10,
        background: '#fdf0d9',
        color: '#7a4a00',
        fontSize: '0.92rem'
    },
    footerNote: {
        color: theme.palette.text.secondary,
        fontSize: '0.9rem'
    },
    footerEmail: {
        color: theme.palette.primary.dark,
        fontSize: '0.9rem',
        userSelect: 'all'
    },
    mutedText: {
        color: theme.palette.text.secondary
    },
    sectionTitle: {
        fontSize: '1.1rem',
        fontWeight: 600,
        color: theme.palette.text.primary
    },
    bgDefault: {
        // Read-only account details: a plain value on a hairline, not a box
        background: 'transparent',
        borderRadius: 0,
        borderBottom: `1px solid ${theme.palette.divider}`,
        "& .MuiInputBase-input.Mui-disabled": {
            color: '#282c34'
        },

    },
    borderEnabled: {
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: 8
    },
    padding5: {
        padding: theme.spacing(5)
    },
    paddingTopBottom3Xs: {
        [theme.breakpoints.down('md')]: {
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3)
        },
        [theme.breakpoints.up('md')]: {
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(8)
        },

    },
    blackBorderButton: {
        border: `1px solid ${theme.palette.divider}`,
        color: theme.palette.text.primary,
        background: theme.palette.background.paper,
        justifyContent: 'flex-start',
        '&:hover': {
            borderColor: theme.palette.primary.main,
            background: theme.palette.primary.light
        }
    },
    warningBtn: {
        color: '#ed6c02',
        border: '1px solid #ed6c02',
    },
    errorBtn: {
        color: 'white !important',
        border: '1px solid red',
        background: 'red',
        '&:hover': {
            backgroundColor: 'red'
        }
    },
    xsButton: {
        padding: '0px 9px',
    },
    card: {
        marginRight: theme.spacing(1)
    },

    icon: {
        cursor: 'pointer'
    },
    marginTop1: {
        marginTop: theme.spacing(1)
    },
    successDiv: {
        display: 'flex',
        justifyContent: 'center',
        padding: '10px',
        background: '#DEEFF8',
        marginBottom: '30px',
        color: '#005894',
    },
    warningDiv: {
        display: 'flex',
        justifyContent: 'center',
        padding: '10px',
        background: '#e7feff',
        marginBottom: '30px',
        color: 'black',
    },
    cardHeader: {
        background: theme.palette.background.field,
        borderRadius: 10,
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        textAlign: 'center'
    },
    bookBtn: {
        textTransform: 'capitalize',
        fontSize: theme.spacing(2.25),
        paddingTop: '4px',
        paddingBottom: '4px'
    },
    ticketCard: {
        padding: theme.spacing(2)
    },
    padding1: {
        padding: theme.spacing(1)
    },
    greyBg: {
        background: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 12
    },
    paddingBottom10: {
        paddingBottom: theme.spacing(10)
    },
    paddingLeftRight1: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1)
    },
    paddingLeftRight2: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    },
    footerText: {
        color: 'grey',
        textAlign: 'center'
    },
    black: {
        color: 'black'
    },
    tabRoot: {
        padding: 0,
        backgroundColor: 'white',
        color: '#3F3F3F',
        "&.Mui-selected": {
            background: theme.palette.primary.main,
            color: 'white'
        }
    },
    inputRoot: {
        padding: 0
    },
    capitalize:{
        textTransform: 'capitalize'
    },
    successMsg: {
        color: theme.palette.secondary.main,
        fontSize: theme.spacing(3)
    },
    info: {
        fontSize: theme.spacing(1.7),
        color: 'grey',
        fontWeight: '600'
    }
    
});


const MyAccount = (props) => {
    const [editClicked, setEditClicked] = useState(false)
    const [addCardClicked, setAddCardClicked] = useState(false)
    const [addBankAcctClicked, setAddBankAcctClicked] = useState(false)
    const [resetPwd, setResetPwd] = useState(false)
    const [registerFlg, setRegisterFlg] = useState(false);
    const account = useSelector(state => state.account)
    const dispatch = useDispatch()
    const isLoginTokenValid = useSelector(state => state.authentication.isLoginTokenValid)
    const currentUser = useSelector(state => state.authentication.currentUser)
    const [accountInState, setAccountInState] = useState(undefined)
    // The renew dialog's confirmed contract details: { details, placeOfBirth }.
    const [renewDetails, setRenewDetails] = useState(null)
    const [loading, setLoading] = useState(true)
    const [successDisplay, setSuccessDisplay] = useState(false)
    const { classes, enqueueSnackbar } = props;
    const location = useLocation()
    const history = useHistory()
    const entryParams = useMemo(() => getEntryParams(location.search), [location.search])
    // entry links (?next=addon-renewal&renewalId=...) continue there after sign-in
    const { nextPath, continueToNext } = useEntryContinuation()

    const [linkToken, setLinkToken] = useState(null);
    const [loadingPlaid, setLoadingPlaid] = useState(false);
    const [onlineBankBtnClicked, setOnlineBankBtnClicked] = useState(false);


    const [payTermsAndCond, setPayTermsAndCond] = useState(undefined)

    const [checkBoxPayTerms, setCheckBoxPayTerms] = useState(false)

    const [, setDiscountExist] = useState(false)
    const [eligibleForAddons, setEligibleForAddons] = useState(false)

    const [upcomingInvoiceAmt, setUpcomingInvoiceAmt] = useState()
    const [optedIn, setOptedIn] = useState(undefined)
    const [addOnModalOpen, setAddOnModalOpen] = useState(false)
    // Whether the renewal schedules have been read (so "already renewed" is known)
    const [phasesChecked, setPhasesChecked] = useState(false)
    // Whether this account's subscriptions have been read into the renewal state
    // (end date, days left, expired), so "can renew now" is not judged early
    const [subscriptionsRead, setSubscriptionsRead] = useState(false)
    const [renewModalOpen, setRenewModalOpen] = useState(false)
    const [addOnTypes] = useState(['Golf', 'Social'])
    const [selectedAddOnsInfo, setSelectedAddOnsInfo] = useState([{email: "", type: 0}])
    const [addOnEmailErr, setAddOnEmailErr] = useState([])
    const [formPristine, setFormPristine] = useState(true)
    const [inviteSendClick, setInviteSendClick] = useState(false)
    const isOAuthRedirect = window.location.href.includes('?oauth_state_id=');
    const [addOnMembers, setAddOnMembers] = useState([])
    const [selectedPricing, setSelectedPricing] = useState(undefined)
    const [upgradeOptions, setUpgradeOptions] = useState([])
    const [defaultPricingSelected, setDefaultPricingSelected] = useState(undefined)
    const [membershipBenefits, setMembershipBenefits] = useState(null)
    const [canellationDateScheduled, setCancellationDateScheduled] = useState(false)
    const [activeSubExists, setActiveSubExists] = useState(false)
    const [membershipStatus, setMembershipStatus] = useState()
    const [cancelAtDate, setCancelAtDate] = useState()
    const [numberOfDaysToExpire, setNumberOfDaysToExpire] = useState()
    const [membershipScheduled, setMembershipScheduled] = useState([])
    const [typeOfMembership, setTypeOfMembership] = useState(null)
    const [renewalSuccessFlg, setRenewalSuccessFlg] = useState(false)
    const [accountCancelled, setAccountCancelled] = useState(false)
    // "Allow my add-ons to be billed on my subscription?" (primaries eligible for add-ons)
    const [paysForAddOns, setPaysForAddOns] = useState(false)
    // Set after an expired member renews onto a live subscription
    const [liveRenewedUntil, setLiveRenewedUntil] = useState(null)
    // From memberFamily: who is viewing, and the primary's stored billing answer
    // known: the family has loaded. Renew stays hidden until then, so a
    // household add-on never sees the primary renew dialog while it loads.
    const [familyRoles, setFamilyRoles] = useState({ known: false, isPrimary: false, isAddOn: false, paysForAddOns: false })
    // An add-on viewer's own renewal still to complete (emailed / in_progress / signed)
    const [ownRenewal, setOwnRenewal] = useState(null)
    // The add-on's own latest renewal (any status), for the term card
    const [ownTerm, setOwnTerm] = useState(null)
    // An add-on the primary pays for: the primary's status, standing and expiry (display only)
    const [coveredMembership, setCoveredMembership] = useState(null)
    // For an add-on viewer: whose household they belong to
    const [householdPrimaryName, setHouseholdPrimaryName] = useState(null)

    // Schedule from the current cancel_at, or a live subscription now if expired
    const renewalPlan = useMemo(
        () => planRenewal({ expired: accountCancelled, cancelAtDate }),
        [accountCancelled, cancelAtDate]
    )

    // onMessage is registered once (the effect below depends on nonce only), so
    // state read inside it is the first render's. What the renewal needs at
    // signing time is read from this ref instead.
    const renewalContextRef = useRef({})
    renewalContextRef.current = { renewalPlan, paysForAddOns, currentUser }


    const nonce = useMemo(() => genHex(), []);
    const sid   = useMemo(() => crypto.randomUUID(), []);
    const [errorSigning, setErrorSigning] = useState(false)

    useEffect(() => {
            window.addEventListener("message", onMessage);
            return () => window.removeEventListener("message", onMessage);
    }, [nonce]);

    
    const onMessage = (ev) => {
        if (ev.origin !== window.location.origin) return;
        const msg = ev.data || {};
        
        if (msg.nonce !== nonce) return;               
        if (!msg.sid || msg.sid !== sid) return;

        
        if(msg.type === "DOCUSIGN_DONE" && msg.event === 'signing_complete'){
            
            renewMembership(msg.memId, msg.startDate, msg.endDate, msg.selectedPricing, msg.isEligibleForAddon)

        }else{
            setErrorSigning(true)
            setRenewalSuccessFlg(false)
            enqueueSnackbar(`Incomplete contract, please try again`, {variant: 'error'})
        }
    }
    
    // The add-on billing answer is saved before the renewal is created (see
    // renewAfterSigning), so the renewal-created webhook sees it.
    const saveAddOnBillingAnswer = (done) => {
        dispatch(setAddOnBillingAuthorization(localStorage.getItem('loginToken'), renewalContextRef.current.paysForAddOns, (err) => {
            if (err) {
                enqueueSnackbar('Your add-on billing choice could not be saved, please contact us', {variant: 'warning'})
            }
            done()
        }))
    }

    const renewMembership = (customerId, startDate, endDate, priceId, isEligibleForAddon) => {
        const mode = renewalContextRef.current.renewalPlan?.mode || RENEWAL_MODES.SCHEDULE
        const isLive = mode === RENEWAL_MODES.LIVE

        const renew = () => dispatch(startRenewal({
            mode, loginToken: localStorage.getItem('loginToken'), customerId, startDate, endDate, priceId
        }, (err) => {
            handleRenewalScheduled(err, {
                onScheduled: () => {
                    setRenewalSuccessFlg(true)
                    if (isLive) {
                        // Open-ended: no end date, the flag only says it renewed.
                        setLiveRenewedUntil(endDate || ONGOING)
                        const user = renewalContextRef.current.currentUser
                        if (user?.userId) {
                            dispatch(getUserInfo(user.userId, () => {}))
                        }
                        enqueueSnackbar('Membership Renewed', {variant: 'success'})
                    } else {
                        fetchMembershipPhases(customerId)
                        enqueueSnackbar('Membership Renewal Scheduled', {variant: 'success'})
                    }
                },
                onError: () => {
                    enqueueSnackbar(isLive
                        ? 'Membership could not be renewed, please contact us'
                        : 'Membership renewal could not be scheduled, please contact us', {variant: 'error'})
                }
            })
        }))

        renewAfterSigning({ isEligibleForAddon, saveAddOnBilling: saveAddOnBillingAnswer, renew })
    };

    // Invite dialog: focus the first email box when it opens, and the new box
    // after Add another. The dialog stays mounted, so autoFocus would not fire.
    const inviteEmailRefs = useRef([])
    const inviteRowCount = useRef(0)
    useEffect(() => {
        if (!addOnModalOpen) {
            inviteRowCount.current = 0
            return
        }
        const count = selectedAddOnsInfo.length
        const index = inviteRowCount.current === 0 ? 0 : count - 1
        const grew = count > inviteRowCount.current
        inviteRowCount.current = count
        if (!grew) return
        // After the slide-in transition has placed the field
        const timer = setTimeout(() => {
            const el = inviteEmailRefs.current[index]
            if (el) el.focus()
        }, 250)
        return () => clearTimeout(timer)
    }, [addOnModalOpen, selectedAddOnsInfo.length])

    // Edit details: remember the values, so Cancel can put them back
    // without saving anything.
    const editSnapshotRef = useRef(null)
    const onEditClick = () => {
        editSnapshotRef.current = { accountInState, optedIn }
        setEditClicked(true)
    }
    const onCancelEdit = () => {
        if (editSnapshotRef.current) {
            setAccountInState(editSnapshotRef.current.accountInState)
            setOptedIn(editSnapshotRef.current.optedIn)
        }
        editSnapshotRef.current = null
        setEditClicked(false)
    }
    const handleOptOut = (e) => {
        setOptedIn(e.target.checked)
    }


    const handleAddOnInviteChange = (type, val, rootIndex) => {
        const updatedAddOns = [...selectedAddOnsInfo];
            if (rootIndex >= 0 && rootIndex < updatedAddOns.length) {
                updatedAddOns[rootIndex] = {
                    ...updatedAddOns[rootIndex],
                    [type]: val
                };
                setSelectedAddOnsInfo(updatedAddOns);
            } else {
                console.warn('Invalid rootIndex:', rootIndex);
        }
        if(!formPristine){
            validateEmails()
        }
    }

    const handleRemoveAddOn = (index) => {
        const updatedAddOns = [...selectedAddOnsInfo]
        updatedAddOns.splice(index, 1)
        setSelectedAddOnsInfo(updatedAddOns)
    }

    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    const onSaveClick = () => {
        if(!isValidEmail(accountInState.email)){
            enqueueSnackbar('Please enter a valid email to proceed', { variant: 'error' });
            return;
        }
        if (accountInState.nameInState === undefined && accountInState.nameInState === '') {
            enqueueSnackbar('Name field cannot be empty', {variant: 'error'})
            return
        }
        dispatch(updateMemberInfo(accountInState.linkToSavedMember, accountInState.phone, accountInState.address, accountInState.dateOfBirth, accountInState.emergencyContact, accountInState.emergencyContactName, (err, data) => {
            if(err){
                enqueueSnackbar('Update failed', { variant: 'error' });
                return
            }
            dispatch(changeAllcalName(accountInState.nameInState))
            dispatch(updateNameAndEmailAcrossPlatforms(accountInState.nameInState, accountInState.email))
            dispatch(getUserInfo(currentUser.userId, () => {
                enqueueSnackbar('Saved', { variant: 'success' });
            }))
            
        }, typeof accountInState.mailingAddress === 'string' ? accountInState.mailingAddress : undefined))
        setEditClicked(false)
        
    }
    const onCardAddClick = () => {
        setAddCardClicked(true)
        setAddBankAcctClicked(false)
        setOnlineBankBtnClicked(false)
    }
    const onOnlineBankClick = () => {
        setOnlineBankBtnClicked(true)
        setAddCardClicked(false)
        setAddBankAcctClicked(false)

    }
    const onBankAcctClick = () => {
        setAddBankAcctClicked(true)
        setAddCardClicked(false)
        setOnlineBankBtnClicked(false)
    }

    const refreshPaymentButtonClicks = () => {
        setOnlineBankBtnClicked(false)
        setAddCardClicked(false)
        setAddBankAcctClicked(false)
    }


    useEffect(() => {
        initGA('UA-214286621-1')
        PageView('/register-tanglewood');

        if (queryString.parse(location.search).regId) {
            setRegisterFlg(true)
        }

        // Admin-generated link: /#/?type=signup&email=... opens the signup form
        if (entryParams.type === ENTRY_TYPES.SIGNUP) {
            setRegisterFlg(true)
        }

        if (isOAuthRedirect) {
            setLinkToken(localStorage.getItem('linkToken'))
            return;
        }

        dispatch(getLinkAccountToken(localStorage.getItem('userId'),"https://rbgolf.com/myaccount/", (err, data) => {
            if (!err) {
                setLinkToken(data.data.link_token)
                localStorage.setItem('linkToken', data.data.link_token)
            }
        }))

    }, [])

    useEffect(() => {
        
        if (account.id) {
            dispatch(getUpcomingInvoice(account.id, (err, upcomingInvoice) => {
                if (upcomingInvoice && upcomingInvoice.total) {
                    setUpcomingInvoiceAmt(upcomingInvoice.total)
                }
            }))
        }

        let primaryMembershipType = getType(account?.registrationTitle)
        
        getMembershipAndUpgradeOptions(primaryMembershipType)
        setTypeOfMembership(primaryMembershipType)
        if(primaryMembershipType === 'Golf' || primaryMembershipType === 'Social'){
            setEligibleForAddons(true)
            if(primaryMembershipType === 'Social'){
                setSelectedAddOnsInfo([{"type": 1, email: ""}])
            }
        }

        fetchMembershipPhases(account?.id)
        

    }, [account])

    const fetchMembershipPhases = (accountId) => {
        if(accountId){
            dispatch(getMembershipPhases(localStorage.getItem('loginToken'), accountId, (err, data) => {
                
                if(!err){
                    if(data?.data.length > 0){
                        setMembershipScheduled(data.data)
            
                    }
                }
                setPhasesChecked(true)
            }))
        } 
    }

    function getType(input) {
        if (!input) return null;

        const text = input.toLowerCase();

        const addOnPattern = /\badd[\s-]*on\b/i;
        const golfPattern = /\bgolf\b/i;
        const socialPattern = /\bsocial\b/i;

        if (addOnPattern.test(text)) {
            if (golfPattern.test(text)) return "Golf Add-on";
            if (socialPattern.test(text)) return "Social Add-on";
            return null; 
        }

        if (golfPattern.test(text)) return "Golf";
        if (socialPattern.test(text)) return "Social";

        return null;
    }



    const getMembershipAndUpgradeOptions = (type) => {

        let option = []
        let priceIdDefault; 
        
        const renewalOption = getRenewalOption(type)
        if(renewalOption){
            option.push(renewalOption)
            priceIdDefault = renewalOption.priceId
        }

        if(type === 'Golf' || type === 'Golf Add-on'){
            setMembershipBenefits(golfMemberBenefits)
        }else if(type === 'Social' || type === 'Social Add-on'){
            setMembershipBenefits(socialMemberBenefits)
        }

        setUpgradeOptions(option)
        setDefaultPricingSelected(priceIdDefault)
    }

    useEffect(() => {
        setAccountInState({
            ...account,
            // The phone lives on the member record (phoneNumber), where Edit
            // details and Confirm your details save it; the Stripe customer's
            // phone is only a fallback for records that have none.
            phone: account && account.phoneNumber ? String(account.phoneNumber) : (account && account.phone)
        })
        if (queryString.parse(location.search).success) {
            setSuccessDisplay(true)
        }
        if (account && Object.keys(account).length > 0) {
            if (account.metadata && account.metadata.recurringPayTermsAgreedOn) {
                setPayTermsAndCond(true)
                setCheckBoxPayTerms(true)
            } else {
                setPayTermsAndCond(false)
            }

            if (account.subscriptions && account.subscriptions.data && account.subscriptions.data.length > 0) {
                let isthereADiscount = false;
                account.subscriptions.data.forEach((subscription) => {
                    if (subscription.discount && subscription.discount.coupon && subscription.discount.coupon.id === 'ACHDISCOUNT') {
                        isthereADiscount = true;
                    }
                    if(subscription.cancel_at){
                        setCancellationDateScheduled(true)
                        setCancelAtDate(moment.tz(subscription.cancel_at * 1000, 'America/New_York').format('MM/DD/YYYY'))
                        const now = moment.tz('America/New_York');
                        const cancelMoment = moment.tz(subscription.cancel_at * 1000, 'America/New_York');
                        const daysToExpire = cancelMoment.diff(now, 'days'); 
                        setNumberOfDaysToExpire(daysToExpire);
                    }
                    if(subscription.status === 'active' || subscription.status === 'past_due'){
                        setActiveSubExists(true)
                        setAccountCancelled(false)
                    }
                    setMembershipStatus(subscription.status?.replace('_', ' '))

                })

                if (isthereADiscount) {
                    setDiscountExist(true)
                } else {
                    setDiscountExist(false)
                }
            }else{
                //setAccountCancelled
                if(typeOfMembership === 'Golf' || typeOfMembership === 'Social'){
                    setAccountCancelled(true)
                }
            }
        }
        
        loadMemberFamily()
        if (account && Object.keys(account).length > 0) setSubscriptionsRead(true)

    }, [account])

    useEffect(() => {
        if (currentUser) {
            setLoading(true)
            dispatch(getUserInfo(currentUser.userId, () => {
                dispatch(getFutureTeeTickets(() => {
                    setLoading(false);

                }))

            }))
        }
    }, [currentUser])


    const handleRecurringPayTermsChange = (e) => {
        setCheckBoxPayTerms(e.target.checked)
    }



    const handleTokenCallback = (token, cb) => {
        dispatch(addNewCard(token, account.id, payTermsAndCond, (err) => {
            if (!err) {
                dispatch(getUserInfo(currentUser.userId, (err, account) => {
                    enqueueSnackbar('Card added successfully', { variant: 'success' });
                    //TO-DO: check if there is discount previously applied on the subscription ; if so remove it 
                    ACHDiscountWrapper(account, 'delete', currentUser, dispatch);
                }))
                setAddCardClicked(false);
            }
        }))
        cb(null)

    }
    const handleBackAcctTokenCallback = (token, cb) => {

        dispatch(addNewBankAcct(token, account.id, payTermsAndCond, (err) => {
            if (!err) {
                dispatch(getUserInfo(currentUser.userId, () => {
                    enqueueSnackbar('Bank Account added successfully', { variant: 'success' });
                }))

                setAddBankAcctClicked(false)
            }
        }))

    }

    const handlePlaidBackAcctTokenCallback = (tokenObj, cb) => {
        setLoadingPlaid(true);

        dispatch(getUserInfo(currentUser.userId, (err, resp) => {

            dispatch(addNewBankAcctAndMakeDefault({ id: tokenObj.stripe_bank_account_token }, resp.id, payTermsAndCond, (err) => {
                if (!err) {
                    dispatch(getUserInfo(currentUser.userId, (err, account) => {
                        enqueueSnackbar('Bank Account added successfully', { variant: 'success' });
                        ACHDiscountWrapper(account, 'apply', currentUser, dispatch)
                    }))

                    setAddBankAcctClicked(false);
                    setLoadingPlaid(false);
                }
            }))
        }));

        refreshPaymentButtonClicks();


    }

    const handlePhoneChangeFn = (tel) => {
        setAccountInState({
            ...accountInState,
            phone: tel
        })
    }
    const handleEmerPhoneChange = (tel) => {
        setAccountInState({
            ...accountInState,
            emergencyContact: tel
        })

    }
    const formatPhoneNumber = (phoneNumberString) => {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            var intlCode = (match[1] ? '+1 ' : '')
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
        } else {
            return phoneNumberString
        }
    }

    const formatTextArea = (address) => {
        if (address) {

            return address.replace(/(\r\n|\n|\r)/gm, " ")
        }
        return address
    }

    const loginFn = (values) => {
        dispatch(signIn(values, (err) => {
            if (!err) {
                if (continueToNext()) { return }
                window.location.reload()
            } else {
                enqueueSnackbar(err, { variant: 'error' })
            }

        }))

    }



    const onAddressChange = (e) => {
        setAccountInState({
            ...accountInState,
            address: e.target.value
        })
    }

    const onMailingAddressChange = (e) => {
        setAccountInState({
            ...accountInState,
            mailingAddress: e.target.value
        })
    }

    const resetFn = () => {
        setResetPwd(true)

    }

    const resetToLogin = () => {
        setRegisterFlg(false);
    }
    const createNewAcctFn = () => {
        setRegisterFlg(true)
    }
    const backToLoginFn = () => {
        setResetPwd(false)

    }

    function sanitizeEmailObj({ email }) {
        if (typeof email !== "string") return { email: "" };

        const sanitized = email
            .trim()
            .toLowerCase()
            .replace(/[^\w.@+-]/g, "");

        return { email: sanitized };
    }



    const resetPwdFn = (values) => {
        dispatch(resetPassword(sanitizeEmailObj(values), (err) => {
            if (!err) {

                enqueueSnackbar('Check your email inbox for further instructions', { variant: 'success' })
                setResetPwd(false)
            }
        }))
    }
    const onNameChange = (e) => {
        setAccountInState({
            ...accountInState,
            nameInState: e.target.value
        })
    }

    const onEmailChange = (e) => {
        setAccountInState({
            ...accountInState,
            email: e.target.value
        })
    }

    const onDOBChange = (date) => {
        setAccountInState({
            ...accountInState,
            dateOfBirth: date
        })
    }

    const handleOpenAddOnDialog = () => {
        setAddOnModalOpen(true)
        setInviteSendClick(false)
    }

    const handleOpenRenewDialog = () => {
        setRenewModalOpen(true)
    }

    const handleCloseAddOnDialog = () => {
        setAddOnModalOpen(false)
        setSelectedAddOnsInfo([{email: "", type: 0}])
    }

    const handleCloseRenewDialog = () => {
        setRenewModalOpen(false)
        setRenewDetails(null)
        // Arrived from a renewal reminder: settle on the account page now.
        if (location.pathname === '/renew') history.replace('/')
    }

    const handleMoreAddOnClick = () => {
        let addOnObj = {email: '', type : 0}
        if(typeOfMembership === 'Social'){
            addOnObj['type'] = 1
        }
        setSelectedAddOnsInfo([
            ...selectedAddOnsInfo,
            addOnObj
        ])
    }

    const validateEmails = () => {
        const errors = [];

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        selectedAddOnsInfo.forEach((item, index) => {
            const email = item.email;

            if (!email || typeof email !== 'string' || email.trim() === '') {
                errors.push({
                    index,
                    message: `Email is required`,
                });
            } else if (!emailRegex.test(email.trim())) {
                errors.push({
                    index,
                    message: `Invalid email format`,
                });
            }
        });
        setAddOnEmailErr(errors)   
        return errors;
    };

    // addOns rows no longer carry a registrationId - that association lives in
    // orgUserRegistrationInfos - so it is derived from the membership type the
    // same way the invite URL always has been.
    const addOnRegIdFor = (type) =>
        (type === 'Golf Add-on') ? constants.golfAddOnRegId : constants.socialAddOnRegId

    const buildInviteMessage = ({ email, type, addOnId }) => {
        const baseUrl = (type === 'Golf Add-on') ? constants.golfAddOnUrl : constants.socialAddOnUrl

        return {
            primaryMemberName: currentUser.name,
            email,
            type,
            regId: addOnRegIdFor(type),
            // The register app reads addOnId to accept this exact row.
            url: addOnId ? `${baseUrl}&addOnId=${addOnId}` : baseUrl
        }
    }

    // revoked and removed rows are history, not members: they are not listed
    // and they must not occupy one of the add-on slots.
    const activeAddOns = addOnMembers.filter(
        (member) => member.status === 'invited' || member.status === 'accepted'
    )
    // What is listed: the active rows, plus (for the primary) removed rows
    // that still have access (spec 7a)
    const listedAddOns = addOnsToList(addOnMembers, { isPrimary: familyRoles.isPrimary })

    // The primary's Renew Membership window; the add-on rows' Renew buttons
    // follow it, and stay open once an expired primary has renewed live
    const renewWindowOpen = isInRenewalWindow({ cancelAtScheduled: canellationDateScheduled, daysToExpire: numberOfDaysToExpire, expired: accountCancelled })
    const primaryRenewed = primaryHasRenewed({ membershipScheduled, liveRenewedUntil, subscriptions: account?.subscriptions?.data })
    const primaryRenewalStart = primaryRenewalStartKey({ membershipScheduled, subscriptions: account?.subscriptions?.data })

    const handleSendInvite = () => {
        setFormPristine(false)
        setInviteSendClick(true)
        const errors =  validateEmails()
        
        if(errors.length === 0){

            selectedAddOnsInfo.forEach((item) => {

                const isGolf = (item.type === 0)
                const type = isGolf ? 'Golf Add-on' : 'Social Add-on'

                // Record the invite first, then send the email: the invite link
                // has to carry the addOns row id so the register app can accept
                // the right row. It also means a row exists even if the email
                // fails, so the member can see it and resend.
                dispatch(logInvitedMember(accountInState.email, item.email, type, addOnRegIdFor(type), 'invited', (logErr, payload) => {
                    const messageInfo = buildInviteMessage({
                        email: item.email,
                        type,
                        addOnId: payload?.data?.addOn?._id
                    })

                    dispatch(inviteUser(messageInfo, constants.SENDGRID_INVITE_ADD_ON_TEMPLATE, () => {
                        loadMemberFamily()
                    }))
                }))
            })
            handleCloseAddOnDialog()
            
        }else{
            setInviteSendClick(false)
        }
    }

    const resendInvite = (member) => {
        dispatch(logInvitedMember(accountInState.email, member.email, member.membershipType, addOnRegIdFor(member.membershipType), 'invited', (logErr, payload) => {
            const messageInfo = buildInviteMessage({
                email: member.email,
                type: member.membershipType,
                addOnId: payload?.data?.addOn?._id || member.addOnId
            })

            dispatch(inviteUser(messageInfo, constants.SENDGRID_INVITE_ADD_ON_TEMPLATE, () => {
                loadMemberFamily()
                enqueueSnackbar('Resent invitation', { variant: 'success' });
            }))
        }))
    }

    const loadMemberFamily = () => {
        dispatch(getMemberFamily((err, family) => {
            if(!err){
                setAddOnMembers(family?.addOns || [])
                setFamilyRoles({
                    known: true,
                    isPrimary: !!family?.self?.isPrimary,
                    // In a primary's household: they renew through the add-on
                    // renewal the primary's renewal sends them, never on their own.
                    isAddOn: !family?.self?.isPrimary && !!family?.primary,
                    paysForAddOns: family?.primary?.paysForAddOns === true
                })
                setOwnRenewal(ownPendingRenewal(family))
                setOwnTerm(ownRenewalTerm(family))
                setCoveredMembership(coveredMembershipDisplay(family, account?.subscriptions?.data))
                setHouseholdPrimaryName(!family?.self?.isPrimary && family?.primary
                    ? [family.primary.firstName, family.primary.lastName].filter(Boolean).join(' ') || null
                    : null)
                // A primary who already said Yes sees it ticked; otherwise unchecked
                if (family?.self?.isPrimary && family?.primary?.paysForAddOns === true) {
                    setPaysForAddOns(true)
                }
            }
        }))
    }



    const onEmergencyContactNameChange = (e) => {
        setAccountInState({
            ...accountInState,
            emergencyContactName: e.target.value
        })
    }

    const deleteCardFn = (cardId) => {
        dispatch(deleteCard(cardId, account.id, (err) => {
            if (!err) {
                dispatch(getUserInfo(currentUser.userId, (err, accountInfo) => {
                    enqueueSnackbar('Card deleted successfully', { variant: 'success' });
                    //TO-DO: Here check if the current default source is bank account - if not revert discount 
                    ACHDiscountWrapper(accountInfo, 'checkAndDelete', currentUser, dispatch);

                }))
            }
        }))
    }
    const makeCardAsDefaultFn = (cardId, customerId) => {
        if (customerId) {
            dispatch(makeCardAsDefault(cardId, customerId, (err, data) => {
                if (!err) {
                    dispatch(getUserInfo(currentUser.userId, (err, accountInfo) => {
                        enqueueSnackbar('Card successfully set as default', { variant: 'success' });
                        //TO-DO: Here check if the current default source is bank account - if yes - check if there is discount already applied - if not apply the discount  
                        ACHDiscountWrapper(accountInfo, 'apply', currentUser, dispatch);
                    }))
                } else {
                    //err toastr
                    enqueueSnackbar('Error setting card as default', { variant: 'error' });
                }

            }))
        } else {

        }

    }

    // Summary values (neutral redesign pass 2)
    const firstName = String((accountInState && accountInState.nameInState) || (currentUser && currentUser.name) || '').trim().split(/\s+/)[0]
    const ownSubscriptions = (account && account.subscriptions && account.subscriptions.data) || []
    const planName = account.registrationTitle || (typeOfMembership ? `${typeOfMembership} Membership` : null)
    const terms = membershipTerms({
        subscriptions: ownSubscriptions,
        scheduled: membershipScheduled,
        liveRenewedUntil,
        expired: accountCancelled,
        covered: coveredMembership,
        ownRenewal: ownTerm,
        type: typeOfMembership,
        selfPayOf: !coveredMembership && familyRoles.isAddOn ? (householdPrimaryName || 'your primary member') : null
    })
    const canRenewNow = renewGate.canRenewNow({
        renewWindowOpen,
        familyRoles,
        alreadyRenewed: !!(account?.stripeUserInfoExists || membershipScheduled?.length > 0 || !!liveRenewedUntil)
    })

    // Arriving from a renewal reminder (/renew): once the page knows whether the
    // member can renew, open the renew dialog. The address stays on /renew while
    // the dialog is open (changing it remounts this page, which would close the
    // dialog) and moves to / when the dialog closes. A member who cannot renew
    // (already renewed, outside the window) goes straight to /, where the
    // "Renewal scheduled" notice explains.
    const arrivedToRenew = location.pathname === '/renew'
    const renewStatusKnown = !loading && !!account && Object.keys(account).length > 0 && subscriptionsRead && (phasesChecked || !account.id) && familyRoles.known
    useEffect(() => {
        if (!arrivedToRenew || !renewStatusKnown) return
        if (canRenewNow) {
            setRenewModalOpen(true)
        } else {
            history.replace('/')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arrivedToRenew, renewStatusKnown, canRenewNow])
    const membershipEndDates = coveredMembership
        ? coveredMembership.expiresOn
        : ownSubscriptions.map((sub) => sub && sub.cancel_at ? moment.tz(sub.cancel_at * 1000, 'America/New_York').format('MMM D, YYYY') : 'Ongoing')

    return <Fragment>{

        isLoginTokenValid && accountInState && <div className={classes.root}>


            <Grid container item wrap='wrap' justify="center" className={classnames(classes.page, classes.paddingTopBottom3Xs)} xs={12} >

                {successDisplay && <Grid item xs={12} ><div className={classes.successDiv} >Your TeeTime has been successfully added to your account
                </div></Grid>}
                
                {/* Summary: who, what, and the next action (neutral redesign pass 2) */}
                <Grid item xs={12}>
                    <div className={classes.summaryHead}>
                        <div>
                            <Typography variant="h5" component="h1">Welcome back{firstName ? `, ${firstName}` : ''}</Typography>
                            <Typography color="textSecondary">
                                {account.registrationTitle || 'Membership'}{accountInState.memberIdProvidedByOrganizer ? ` · Member ID ${accountInState.memberIdProvidedByOrganizer}` : ''}{householdPrimaryName ? ` · Part of ${householdPrimaryName}'s household` : ''}
                            </Typography>
                        </div>
                        <div className={classes.summaryActions}>
                            {ownRenewal && <Button
                                variant="contained"
                                color="primary"
                                onClick={() => history.push('/addon-renewal/' + ownRenewal.renewalId)}
                            >
                                Complete your renewal
                            </Button>}
                            {renewGate.showRenewButton({ renewWindowOpen, familyRoles }) && <Button
                                variant="contained"
                                color="primary"
                                disabled={account?.stripeUserInfoExists || membershipScheduled?.length > 0 || !!liveRenewedUntil}
                                onClick={handleOpenRenewDialog}
                            >
                                Renew membership
                            </Button>}
                        </div>
                    </div>
                    {liveRenewedUntil && membershipScheduled?.length === 0 && <div className={classes.notice}>
                        {liveRenewedUntil === ONGOING
                            ? <>You are all set! Membership renewed. It continues, <strong>billed monthly</strong>.</>
                            : <>You are all set! Membership renewed through <strong>{moment.tz(liveRenewedUntil, 'MM/DD/YYYY', 'America/New_York').format('MMM D, YYYY')}</strong></>}
                    </div>}
                    {membershipScheduled?.length > 0 && <div className={classes.notice}>
                        You are all set! Renewal scheduled on <strong>{moment.tz(membershipScheduled[0]?.phases[0]?.start_date * 1000, 'America/New_York').format('MMM D, YYYY')}</strong>
                    </div>}
                    <div className={classes.tiles}>
                        <div className={classnames(classes.tile, classes.tilePrimary)}>
                            <span className={classes.tileLabel}>Membership</span>
                            <span className={classes.tileValue}>{account.registrationTitle || '-'}</span>
                        </div>
                        <div className={classes.tile}>
                            <span className={classes.tileLabel}>Status</span>
                            <span>{coveredMembership
                                ? (coveredMembership.status ? <StatusBadge label={coveredMembership.status} /> : '-')
                                : membershipStatus ? <StatusBadge label={membershipStatus} /> : (accountCancelled ? <StatusBadge label="Expired" /> : '-')}</span>
                            {coveredMembership && coveredMembership.primaryName && <span className={classes.tileSub}>Through {coveredMembership.primaryName}'s membership</span>}
                        </div>
                        {(coveredMembership || account.stripeUserInfoExists !== false) && <div className={classes.tile}>
                            <span className={classes.tileLabel}>Standing</span>
                            <span>{(coveredMembership ? coveredMembership.delinquent : account.delinquent) ? <StatusBadge label="Delinquent" /> : <StatusBadge label="Good" />}</span>
                        </div>}
                        <div className={classes.tile}>
                            <span className={classes.tileLabel}>{accountCancelled ? 'Membership expired' : membershipEndDates.length && membershipEndDates.every((d) => d === 'Ongoing') ? 'Membership' : 'Membership ends'}</span>
                            {loading && !coveredMembership
                                ? <CircularProgress size={16} />
                                : membershipEndDates.length > 0
                                    ? membershipEndDates.map((date, i) => <span key={i} className={classes.tileValue}>{date}</span>)
                                    : (!accountCancelled && <span className={classes.tileSub}>NA - Please contact us</span>)}
                            {!coveredMembership && canellationDateScheduled && numberOfDaysToExpire >= 0 && <span className={classes.tileSub}>{numberOfDaysToExpire} days left</span>}
                            {!coveredMembership && !accountCancelled && membershipEndDates.length > 0 && membershipEndDates.every((d) => d === 'Ongoing') && <span className={classes.tileSub}>Billed monthly</span>}
                        </div>
                    </div>
                </Grid>

                {/* Membership term: current and next */}
                <Grid item xs={12}>
                    <TermCard className={classes.sectionCard} terms={terms} planName={planName} onRenew={canRenewNow ? handleOpenRenewDialog : null} />
                </Grid>

                {/* Household add-ons */}
                {familyRoles.isPrimary && <Grid item xs={12}>
                    <Paper className={classes.sectionCard}>
                        <div className={classes.cardHeadRow}>
                            <Typography className={classes.sectionTitle} component="h2">Household add-ons</Typography>
                            <div className={classes.summaryActions}>
                                {familyRoles.isPrimary && <Typography variant="body2" color="textSecondary" style={{ alignSelf: 'center' }}>{activeAddOns.length} of 3 places used</Typography>}
                                {familyRoles.isPrimary && <Button
                                    variant="outlined"
                                    color="primary"
                                    disabled={(account.stripeUserInfoExists === false) || !eligibleForAddons || activeAddOns.length >= 3 || !activeSubExists || membershipScheduled.length > 0}
                                    onClick={handleOpenAddOnDialog}
                                >
                                    Invite add-on member
                                </Button>}
                            </div>
                        </div>
                        {membershipScheduled.length > 0 && eligibleForAddons && familyRoles.isPrimary && <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                            You will be able to invite add-on members on {moment.tz(membershipScheduled[0]?.phases[0]?.start_date * 1000, 'America/New_York').format('MMM D, YYYY')}
                        </Typography>}
                        <Grid container item className={classes.marginTop2}>
                            <AddOnMemberList
                                members={listedAddOns}
                                onResend={resendInvite}
                                isPrimary={familyRoles.isPrimary}
                                renewWindowOpen={renewWindowOpen || primaryRenewed}
                                primaryRenewed={primaryRenewed}
                                paysForAddOns={familyRoles.paysForAddOns}
                                primaryRenewalStart={primaryRenewalStart}
                                onRenewalSent={loadMemberFamily}
                                primaryName={(accountInState && accountInState.nameInState) || (currentUser && currentUser.name) || null}
                            />
                        </Grid>
                    </Paper>
                </Grid>}

                {accountInState && <Grid item md xs={12} >
                    <Paper className={classes.sectionCard}>
                        <Grid item className={classnames(classes.bold)} >
                            <Paper className={classnames(classes.bgTransparent, classes.sectionTitle)}>Your upcoming Tee Times</Paper>
                        </Grid>

                        {
                            accountInState && accountInState.tickets && accountInState.tickets.length > 0 ?
                                <Fragment>
                                    <Grid container justify="space-between" className={classnames(classes.marginTop2)}>

                                        {accountInState.tickets.map((ticket, index) => {
                                            return <Grid key={index} container item xs={12} sm={6} className={classes.padding1} >
                                                <Grid container justify="space-between" alignItems="center" className={classnames(classes.greyBg)} >
                                                    <Grid item xs={8}>
                                                        <Grid container direction="column" spacing={1} className={classes.ticketCard}>
                                                            <Grid item >{ticket.player.name}</Grid>
                                                            <Grid item className={classes.bold}>{ticket.postingMeta.title}  | {ticket.eventInfo.eventDateStr}</Grid>
                                                            <Grid item >1 person</Grid>
                                                            <Grid item >{ticket.eventInfo.eventLocation}</Grid>
                                                        </Grid>

                                                    </Grid>
                                                    <Grid item xs={4} >
                                                        <Grid container justify="flex-end" className={classes.ticketCard}>
                                                            <QRCode
                                                                bgColor="#FFFFFF"
                                                                fgColor="#000000"
                                                                level="Q"
                                                                style={{ width: '120px', height: '100%' }}
                                                                value={ticket.ticketId}
                                                            />
                                                        </Grid>

                                                    </Grid>
                                                </Grid>

                                            </Grid>
                                        })}

                                    </Grid>

                                </Fragment>
                                : !loading ? <Grid container item justify="center" className={classnames(classes.marginTop3, classes.cardHeader)}>
                                    <Grid container item xs={12} md={10} lg={7} spacing={2} direction={'column'}>
                                        <Grid item  >
                                            You have no tee times booked right now
                                        </Grid>
                                        <Grid container item justify="center">
                                            <Grid item xs={10} sm={6} lg={5} >
                                                <Button className={classes.bookBtn} variant="contained" onClick={() => { window.location.href = "https://tanglewood-teetimes.allcal.com/#/" }} fullWidth={true} size="large" color="primary">Book Tee Time</Button>
                                            </Grid>
                                        </Grid>
                                        <Grid item >
                                            {/* TO-DO */}
                                            Questions about your Tee Time or need to make a change? Please call our Pro Shop: <span className={classnames(classes.bold, classes.paddingLeftRight1)}>903-786-4638</span> 
                                        </Grid>
                                    </Grid>

                                </Grid> : <Grid container item justify="center"><Grid item><CircularProgress size={24} className={classes.marginTop3} ></CircularProgress></Grid></Grid>
                        }


                    </Paper>
                </Grid>}
                <Grid container justifyContent='space-between' item>
                    <Grid item md={6} xs={12}>

                    <Paper className={classnames(classes.sectionCard)}>
                <Grid container item justify="space-between" alignItems="center">
                    <Grid item className={classnames(classes.bold)} >
                        <Paper className={classnames(classes.bgTransparent, classes.sectionTitle)}>Account Details</Paper>
                    </Grid>
                    <Grid item className={classnames(classes.bold)} >
                        {!editClicked ? <Button
                            variant="outlined"
                            color="primary"
                            disabled={account.paperInfoExists === false}
                            onClick={onEditClick}
                            size="small"
                            startIcon={<EditIcon className={classes.icon} fontSize="large" ></EditIcon>}

                        >
                            Edit Details
                        </Button> : <span style={{ display: 'inline-flex', gap: 8 }}>
                            <Button
                                variant="outlined"
                                onClick={onCancelEdit}
                                size="small"
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={onSaveClick}
                                size="small"
                                startIcon={<CheckBoxIcon className={classes.icon} fontSize="large" ></CheckBoxIcon>}
                            >
                                Save Details
                            </Button>
                        </span>}
                    </Grid>

                </Grid>

                        <Grid container className={classes.marginTop2} alignItems="center" >
                            <Grid item xs={12} sm={3} ><Paper className={classes.bgTransparent}>Name</Paper></Grid>
                            <Grid item xs><Paper className={classnames(editClicked ? classes.bgWhite : classes.bgDefault, editClicked ? classes.borderEnabled : '')}><TextField InputProps={{ disableUnderline: true, disabled: !editClicked }} fullWidth placeholder="Enter name" value={accountInState.nameInState ? accountInState.nameInState : currentUser.name} onChange={onNameChange} /></Paper></Grid>
                        </Grid>
                        <Grid container className={classes.marginTop2} alignItems="center">
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Member ID</Paper></Grid>
                            <Grid item xs><Paper className={classnames(editClicked ? classes.bgWhite : classes.bgDefault)}><TextField InputProps={{ disableUnderline: true, disabled: true }} fullWidth placeholder="Not provided" value={accountInState.memberIdProvidedByOrganizer || ''} /></Paper></Grid>
                        </Grid>

                        <Grid container className={classes.marginTop2} alignItems="center">
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Email</Paper></Grid>
                            <Grid item xs><Paper className={classnames(editClicked ? classes.bgWhite : classes.bgDefault, editClicked ? classes.borderEnabled : '')}><TextField InputProps={{ disableUnderline: true, disabled: !editClicked }} fullWidth value={accountInState.email ? accountInState.email : currentUser.email} onChange={onEmailChange} /></Paper></Grid>
                        </Grid>
                        <Grid container className={classes.marginTop2} alignItems="center">
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Date of Birth</Paper></Grid>
                            <Grid item xs>{!editClicked ? <Paper className={classnames(editClicked ? classes.bgWhite : classes.bgDefault, editClicked ? classes.borderEnabled : '')}> <TextField InputProps={{ disableUnderline: true, disabled: !editClicked }} fullWidth placeholder={editClicked ? 'Enter Date of Birth' : 'Not provided'} value={!loading && accountInState.dateOfBirth ? moment(accountInState.dateOfBirth).format('MM/DD/YYYY') : ''} /></Paper>
                                : <DatePicker selectedDate={accountInState.dateOfBirth ? accountInState.dateOfBirth : new Date().toISOString()} onChangeDate={onDOBChange}></DatePicker>}</Grid>
                        </Grid>

                        <Grid container className={classes.marginTop2} alignItems="center">
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Phone</Paper></Grid>
                            <Grid item xs><Paper className={classnames(editClicked ? classes.bgWhite : classes.bgDefault, editClicked ? classes.borderEnabled : '')}>
                                {editClicked ? <PhoneInput value={accountInState.phone} handlePhoneChange={handlePhoneChangeFn}></PhoneInput> : <TextField InputProps={{ disableUnderline: true, disabled: !editClicked }} fullWidth value={accountInState.phone ? formatPhone334(accountInState.phone) : ''} />}

                            </Paper></Grid>
                        </Grid>
                        <Grid container >
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}></Paper></Grid>
                            <Grid item xs>
                                <FormGroup row>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={optedIn}
                                                onChange={handleOptOut}
                                                name="checkedB"
                                                color="primary"
                                            />
                                        }
                                        label={optedIn === true ? 'Subscribed to receive member communication messages' :  'Check this box to receive member communication messages' }
                                    />
                                </FormGroup>
                            </Grid>
                            
                        </Grid>
                        <Grid container className={classes.marginTop2} alignItems="center">
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Address</Paper></Grid>
                            <Grid item xs>

                                {!editClicked ? <Paper className={classnames(editClicked ? classes.bgWhite : classes.bgDefault, editClicked ? classes.borderEnabled : '')}>
                                    <TextField InputProps={{ disableUnderline: true, disabled: !editClicked }} fullWidth placeholder={editClicked ? 'Enter Address' : 'Not provided'} value={formatTextArea(accountInState.address)} onChange={onAddressChange} />
                                </Paper> : <TextareaAutosize style={{ width: '100%', padding: '12px', borderRadius: '6px', border: '1px solid black' }} InputProps={{ disableUnderline: true, disabled: !editClicked }} fullWidth placeholder={editClicked ? 'Enter Address' : 'Not provided'} value={accountInState.address} onChange={onAddressChange} />}

                            </Grid>

                        </Grid>
                        <Grid container className={classes.marginTop2} alignItems="center">
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Mailing address</Paper></Grid>
                            <Grid item xs>
                                {!editClicked ? <Paper className={classes.bgDefault}>
                                    <TextField InputProps={{ disableUnderline: true, disabled: true }} fullWidth placeholder='Same as home address' value={typeof accountInState.mailingAddress === 'string' ? formatTextArea(accountInState.mailingAddress) : ''} />
                                </Paper> : <TextareaAutosize style={{ width: '100%', padding: '12px', borderRadius: '6px', border: '1px solid black' }} placeholder='Leave empty if the same as home' value={typeof accountInState.mailingAddress === 'string' ? accountInState.mailingAddress : ''} onChange={onMailingAddressChange} />}
                            </Grid>
                        </Grid>
                        <Grid container className={classes.marginTop2} alignItems="center">
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Emergency Contact Name</Paper></Grid>
                            <Grid item xs><Paper className={classnames(editClicked ? classes.bgWhite : classes.bgDefault, editClicked ? classes.borderEnabled : '')}><TextField InputProps={{ disableUnderline: true, disabled: !editClicked }} fullWidth placeholder={editClicked ? 'Enter Emergency Contact Name' : 'Not provided'} value={accountInState.emergencyContactName} onChange={onEmergencyContactNameChange} /></Paper></Grid>
                        </Grid>
                        <Grid container className={classes.marginTop2} alignItems="center">
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Emergency Contact Phone</Paper></Grid>
                            <Grid item xs><Paper className={classnames(editClicked ? classes.bgWhite : classes.bgDefault, editClicked ? classes.borderEnabled : '')}>
                                {editClicked ? <PhoneInput value={accountInState.emergencyContact} handlePhoneChange={handleEmerPhoneChange}></PhoneInput> : <TextField InputProps={{ disableUnderline: true, disabled: !editClicked }} fullWidth value={formatPhoneNumber(account.emergencyContact)} />}

                            </Paper></Grid>
                        </Grid>
                        <Grid container className={classes.marginTop2} alignItems="center">
                            <Grid item xs={12} sm={3}><Paper className={classes.bgTransparent}>Member Since</Paper></Grid>
                            <Grid item xs><Paper className={classnames(editClicked ? classes.bgWhite : classes.bgDefault)}><TextField InputProps={{ disableUnderline: true, disabled: true }} fullWidth value={!loading ? moment(account.createdTime).format('MMM D, YYYY') : ''} /></Paper></Grid>
                        </Grid>

                    </Paper>


                    </Grid>
                <Grid item md={5} xs={12}>
                    <Paper className={classnames(classes.sectionCard)}>
                        <Grid container item direction="column" >

                           <SlideInModal handleClose={() => handleCloseAddOnDialog()} openModal={addOnModalOpen}
                                title="Invite add-on members"
                                subtitle="Family members in your household · up to 3 per membership">
                                <Grid container spacing={3} direction='column' className={classes.paddingBottom10}>
                                    <Grid item>
                                        <div className={classes.tiles} style={{ marginTop: 0 }}>
                                            <div className={classes.tile}>
                                                <span className={classes.tileLabel}>Golf Add-on</span>
                                                <span className={classes.tileValue}>{currentPricing.Golf_Addon.amount} <span className={classes.tileSub}>+ tax</span></span>
                                            </div>
                                            <div className={classes.tile}>
                                                <span className={classes.tileLabel}>Social Add-on</span>
                                                <span className={classes.tileValue}>{currentPricing.Social_Addon.amount} <span className={classes.tileSub}>+ tax</span></span>
                                            </div>
                                        </div>
                                        <Typography variant="body2" color="textSecondary" style={{ marginTop: 10 }}>
                                            Benefits are the same as a Golf or Social member. Add-on members must be in the same household as the primary member.
                                        </Typography>
                                    </Grid>

                                    <Grid item>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                                    {selectedAddOnsInfo.map((addOn, rootIndex) => <div key={rootIndex}>
                                        <div className={classes.inviteRow}>
                                            <TextField
                                                required
                                                label={'Email for add-on #' + (rootIndex + 1)}
                                                variant="outlined"
                                                size="small"
                                                type='email'
                                                value={addOn.email}
                                                helperText={addOnEmailErr.find(err => err.index === rootIndex)?.message}
                                                error={!!addOnEmailErr.find(err => err.index === rootIndex)}
                                                onChange={(e) => handleAddOnInviteChange('email', e.target.value, rootIndex)}
                                                inputRef={(el) => { inviteEmailRefs.current[rootIndex] = el }}
                                                InputLabelProps={{ className: classes.inviteLabel }}
                                                className={classes.inviteEmail}
                                            />
                                            <ToggleButtonGroup
                                                exclusive
                                                size="small"
                                                value={addOn.type}
                                                onChange={(e, value) => { if (value !== null) handleAddOnInviteChange('type', value, rootIndex) }}
                                                aria-label={'Membership for add-on #' + (rootIndex + 1)}
                                                className={classes.inviteToggleGroup}
                                            >
                                                {addOnTypes.map((type, index) => <ToggleButton
                                                    key={type}
                                                    value={index}
                                                    disabled={typeOfMembership === 'Social'}
                                                    className={classes.inviteToggle}
                                                >{type} Add-on</ToggleButton>)}
                                            </ToggleButtonGroup>
                                            {selectedAddOnsInfo.length > 1 && <IconButton aria-label={'Remove add-on #' + (rootIndex + 1)} onClick={() => handleRemoveAddOn(rootIndex)}>
                                                <CloseIcon />
                                            </IconButton>}
                                        </div>
                                    </div>)}
                                    </div>
                                    </Grid>

                                    <Grid item>
                                        <div className={classes.cardHeadRow}>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                disabled={selectedAddOnsInfo.length > 2 || activeAddOns.length >= 2}
                                                onClick={handleMoreAddOnClick}
                                            >
                                                + Add another
                                            </Button>
                                            <Button
                                                variant='contained'
                                                color="primary"
                                                onClick={handleSendInvite}
                                                disabled={inviteSendClick}
                                            >
                                                Send invite
                                            </Button>
                                        </div>
                                    </Grid>
                                </Grid>
                           </SlideInModal>

                           <SlideInModal handleClose={() => handleCloseRenewDialog()} openModal={renewModalOpen}
                                title="Renew your membership" subtitle={account.registrationTitle || null}
                                steps={['Plan and details', 'Sign', 'Done']} activeStep={renewalSuccessFlg ? 2 : (renewDetails ? 1 : 0)}>
                                 <Grid container spacing={3} direction='column' className={classes.paddingBottom10}>
                                    <Grid container item justifyContent='center'>
                                        {!renewalSuccessFlg ? eligibleForAddons && <Typography className={classes.warnNotice} >Please renew at the earliest to avoid <span className={classnames(classes.bold)}>{(typeOfMembership === 'Golf') ? '$3000' : '$1000'} initiation fee!</span></Typography> : 
                                        <Typography className={classes.notice} style={{ width: '100%' }}>Thanks for renewing your membership!</Typography>
                                        }
                                    </Grid>
                                    <Grid container item>
                                        { account?.id && <MembershipUpgrades  benefitsList={membershipBenefits} defaultPricingSelected={defaultPricingSelected} upgradeOptions={upgradeOptions} customerId={account.id} handleChange={(priceId) => { setSelectedPricing(priceId) }}></MembershipUpgrades>}
                                    </Grid>
                                    {!renewalSuccessFlg && eligibleForAddons && <Grid container item>
                                        <AddOnBillingQuestion eligible={eligibleForAddons} checked={paysForAddOns} onChange={setPaysForAddOns} />
                                    </Grid>}
                                    {!renewalSuccessFlg ?  <Grid container item direction='column'>
                                        {!renewDetails ? <ConfirmDetails
                                            continueLabel='Save and continue to signing'
                                            onConfirmed={(confirmed) => {
                                                setRenewDetails(confirmed)
                                                // so Account details shows what was just saved
                                                if (currentUser && currentUser.userId) dispatch(getUserInfo(currentUser.userId, () => {}))
                                            }}
                                        /> : <>
                                            <div data-testid='renew-details-summary' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                                                <Typography variant='body2' color='textSecondary'>Details confirmed for the agreement.</Typography>
                                                <Button size='small' color='primary' onClick={() => setRenewDetails(null)}>Edit</Button>
                                            </div>
                                            <ContractSign nonce={nonce} sid={sid} error={errorSigning} handleClose={handleCloseRenewDialog} startDate={renewalPlan?.startDate} endDate={renewalPlan?.endDate}
                                                regTitle={account?.registrationTitle || (typeOfMembership ? `${typeOfMembership} Membership` : null)}
                                                selectedPricing={selectedPricing || defaultPricingSelected} isEligibleForAddon={eligibleForAddons}
                                                memberInfo={{...accountInState, ...currentUser}}
                                                confirmedDetails={renewDetails.details} placeOfBirth={renewDetails.placeOfBirth} ></ContractSign>
                                        </>}
                                        </Grid> : <Grid container justifyContent='center' alignItems='center'>
                                        <Grid item>
                                                You are all Set! <CheckCircleOutlineIcon color="secondary"  style={{ 'fontSize': '24px'}}/>
                                            </Grid>
                                        </Grid>
                                    }
                                    
                                </Grid>
                           </SlideInModal>


                            <Typography className={classes.sectionTitle} component="h2">Billing</Typography>
                            <div style={{ marginTop: 12 }}>
                                <AutopayPanel refreshKey={`${account?.default_source || ''}|${account?.invoice_settings?.default_payment_method || ''}|${(account?.sources?.data || []).length}`} />
                            </div>
                            <Grid container direction="column" spacing={1} >
                                <Grid item ><Paper className={classnames(classes.bold, classes.marginTop2, classes.bgTransparent)}>Payment methods {loadingPlaid && <CircularProgress size={16}></CircularProgress>}</Paper></Grid>

                                {account.sources && account.sources.data.length > 0 ?

                                    account.sources.data.map((card) => {
                                        return card.type !== 'ach_credit_transfer' && <Grid item container justify="space-between" alignItems="center" className={classes.marginBottom1}><Grid container item xs={10} alignItems="center" >
                                            <Paper className={classnames(classes.bgDefault, classes.card)}>{card.brand ? card.brand : card.bank_name} ending in {card.last4} </Paper>
                                            {card.object !== 'bank_account' ?
                                                <Button size="small" className={classes.xsButton} color={card.id === account.default_source ? 'primary' : 'none'} variant={card.id === account.default_source ? 'contained' : 'text'} onClick={() => makeCardAsDefaultFn(card.id, account.id)}> DEFAULT</Button>
                                                :
                                                <Fragment>
                                                    {card.status === 'verified' ? <Button size="small" className={classes.xsButton} color={card.id === account.default_source ? 'primary' : 'none'} variant={card.id === account.default_source ? 'contained' : 'text'} onClick={() => makeCardAsDefaultFn(card.id, account.id)}> DEFAULT</Button> :
                                                        <Button size="small" className={classes.xsButton} color={card.status === account.default_source ? 'primary' : 'none'} variant={card.id === account.default_source ? 'contained' : 'text'} > {card.status === 'new' ? 'Unverified' : card.status}</Button>

                                                    }
                                                </Fragment>
                                            }
                                        </Grid>
                                            { account?.sources?.data && account?.sources?.data.length > 1 && <Grid container alignItems="center" item xs justify="flex-end">
                                                <DeleteForeverIcon className={classnames(classes.red, classes.icon)} onClick={() => { deleteCardFn(card.id) }}>
                                                </DeleteForeverIcon></Grid> 
                                            }

                                            {
                                                card.object === 'bank_account' && (card.status === 'new' || card.status === 'verification_failed' || card.status === 'errored') && <Grid container>
                                                    <VerifyAmountForm customerId={account.id} source={card.id} ></VerifyAmountForm>
                                                </Grid>
                                            }

                                        </Grid>
                                    })

                                    : <Grid item ><Paper className={classnames(classes.bgTransparent, classes.mutedText)}>No cards or bank accounts on file</Paper></Grid>
                                }
                                {(!addCardClicked) && <Grid item xs><Button
                                    variant="outlined"
                                    color="primary"
                                    disabled={account.stripeUserInfoExists === false}
                                    onClick={onCardAddClick}
                                    className={classes.blackBorderButton}
                                    size="large"
                                    fullWidth={true}
                                >
                                    + Add New Card
                                </Button></Grid>}
                                {addCardClicked && <CardForm disabled={payTermsAndCond} handleTokenCallback={handleTokenCallback}></CardForm>}
                                {linkToken && <Grid item xs><Button
                                    variant="outlined"
                                    color="primary"
                                    disabled={account.stripeUserInfoExists === false}
                                    onClick={onOnlineBankClick}
                                    className={classes.blackBorderButton}
                                    size="large"
                                    fullWidth={true}
                                >
                                    + Online Banking - add Bank account
                                </Button></Grid>}

                                {
                                    onlineBankBtnClicked && <Fragment><Grid item >
                                        {!payTermsAndCond && <FormGroup aria-label="position" row>
                                            <FormControlLabel
                                                value="end"
                                                control={<Checkbox color="primary" value={checkBoxPayTerms} onChange={handleRecurringPayTermsChange} />}
                                                label={<div>I agree to the recurring payment <MaterialLink target="_blank" href="https://register.tanglewoodresort.club/#/recurring-payment-terms">terms and conditions</MaterialLink>.</div>}
                                                labelPlacement="end"
                                            />
                                        </FormGroup>}
                                    </Grid><Grid container item justify="flex-end">{linkToken && <LinkAccountButton primaryColor={true} fullWidth={false} disabled={checkBoxPayTerms} stripeUserInfoExists={account.stripeUserInfoExists} token={linkToken} handleTokenCallback={handlePlaidBackAcctTokenCallback} isOAuthRedirect={isOAuthRedirect} label="continue"></LinkAccountButton>}
                                        </Grid></Fragment>
                                }


                                {!addBankAcctClicked && <Grid item xs><Button
                                    variant="outlined"
                                    color="primary"
                                    disabled={account.stripeUserInfoExists === false}
                                    onClick={onBankAcctClick}
                                    className={classes.blackBorderButton}
                                    size="large"
                                    fullWidth={true}
                                >
                                    + Add Bank Account
                                </Button></Grid>}
                                {addBankAcctClicked && <BankAccountForm disabled={payTermsAndCond} handleTokenCallback={handleBackAcctTokenCallback}></BankAccountForm>}

                            </Grid>

                            <Grid container direction="column" spacing={1} >
                                <Grid item ><Paper className={classnames(classes.bold, classes.marginTop3, classes.bgTransparent)}>Upcoming invoice</Paper></Grid>

                                {account.subscriptions && account.subscriptions.data && account.subscriptions.data.length > 0 ?
                                    account.subscriptions.data.map((sub) => <Grid item >{upcomingInvoiceAmt && <Paper className={classes.bgTransparent}><div className={classes.tileValue}>{(upcomingInvoiceAmt / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</div><div className={classes.tileSub}>Due {moment(sub.current_period_end * 1000).format('MMM D')} · includes pending member charges</div></Paper>}</Grid>)
                                    : <Grid item > {!loading ? <Paper className={classnames(classes.bgTransparent, classes.mutedText)}>None</Paper> : <CircularProgress size={16}></CircularProgress>} </Grid>
                                }

                            </Grid>


                            <Grid container direction="column" spacing={1} >
                                <Grid item ><Paper className={classnames(classes.bold, classes.marginTop3, classes.bgTransparent)}>Pending charges</Paper></Grid>
                                {account.invoiceItems && account.invoiceItems.length > 0 ?
                                    account.invoiceItems.map((invoice) => <Grid item> <Paper className={classes.bgTransparent}><strong>{(invoice.amount / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</strong> {invoice.description} <span className={classes.tileSub}>· added {moment(invoice.date * 1000).format('MMM D, YYYY')}</span></Paper> </Grid>)
                                    : <Grid item>{!loading ? <Paper className={classnames(classes.bgTransparent, classes.mutedText)}>None</Paper> : <CircularProgress size={16}></CircularProgress>} </Grid>
                                }


                            </Grid>


                        </Grid>
                    </Paper>
                </Grid>
                </Grid>
                
                <Grid container justify="center" spacing={1} className={classnames(classes.marginTop3, classes.footerText)} >
                    {accountInState && accountInState.tickets && accountInState.tickets.length > 0 && <Grid item xs={12} >
                        Questions about your Tee Time or need to make a change? Please call our Pro Shop: <span className={classnames(classes.bold, classes.paddingLeftRight1, classes.black)}>  </span>

                    </Grid>}
                    <Grid item xs={12} >
                        {/* TO-DO: admin email */}
                        <span className={classes.footerNote}>Questions about your account? Email Tanya Vincent at</span><span className={classnames(classes.bold, classes.paddingLeftRight1, classes.footerEmail)}>tvincent@tanglewoodresort.com  </span>
                    </Grid>
                </Grid>

            </Grid>

        </div >

    }
        {
            !isLoginTokenValid && < div className={classes.root}>
                <Grid container item xs={12} justify="center" className={classes.authWrap}>
                    <div className={classes.authCard}>

                    <AuthEntry
                        mode={resetPwd ? AUTH_MODES.RESET : registerFlg ? AUTH_MODES.SIGNUP : AUTH_MODES.LOGIN}
                        prefilledEmail={entryParams.email}
                        loginFn={loginFn}
                        resetFn={resetFn}
                        createNewAcctFn={createNewAcctFn}
                        resetToLogin={resetToLogin}
                        resetPwdFn={resetPwdFn}
                        backToLoginFn={backToLoginFn}
                        nextPath={nextPath}
                        onAuthenticated={continueToNext}
                        linkExpired={entryParams.linkExpired}
                    />
                    </div>
                </Grid>
            </div>
        }


    </Fragment >

}


export default withStyles(styles)(withSnackbar(MyAccount))